import { render, staticRenderFns } from "./GradientBackground.vue?vue&type=template&id=54d0c583"
import script from "./GradientBackground.vue?vue&type=script&lang=js"
export * from "./GradientBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports